import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageService } from '@ui-lib';
import { AuthService } from '../../services/auth/auth.service';
import { OtpService } from '../../services/otp/otp.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const otpService = inject(OtpService);
  const languageService = inject(LanguageService);

  const headers: Record<string, string> = {
    'Accept-Language': languageService.currentLanguage(),
  };

  // Use OTP token if available, otherwise use auth token
  const token = otpService.getOtpToken() || authService.getToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return next(req.clone({ setHeaders: headers }));
};
